<template>
    <div class="detail-content" :class="[{pc: !mobile}, {mb: mobile}]">

        <!-- Title -->
        <template v-if="!mobile">
            <div class="title" v-if="!loading">
                    <img src="/static/images/icon-st.jpg" />
                    <span>{{course.courseName}}</span>
            </div>
        </template>

        <template v-if="mobile">
            <div v-if="!loading" class="title_mb nqt_titl_7283">
                <span>{{course.courseName}}</span>
            </div>
        </template>

        <!-- Controls -->
        <div class="div-icon-curi" v-if="!loading">
            <ul class="div-btn-icon nqt_hid">
                <template v-for="(item, index) in btns">
                    <li v-if="item.show" :key="index" @click="handleClickItem(item)">
                        <p :class="[{'btn-next-1': item.name == 'BACK'}]">
                            <img :src="item.img"/>
                            <span>{{$t(item.lg)}}</span>
                        </p>
                    </li>
                </template>
            </ul>
        </div>

        <!-- Menu -->
        <component ref="child" :is="child"></component>

        <!-- Dialog -->
        <el-dialog custom-class="_nqt_dialog" :title="$t('new.title19')" :visible.sync="showFinished" :modal="true" :width="setDialogWidth()" :center="true">
            <template v-if="!loading">
                <div style="vertical-align: middle; text-align: center;">
                    <el-timeline style="display: inline-block; text-align: left;">
                        <el-timeline-item style="color: white;" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="course.curriculumInfo.timestamp1">
                            {{$t("new.title20")}}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep2 == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="course.curriculumInfo.timestamp2">
                            {{$t("new.title22")}}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep2 == 2" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="course.curriculumInfo.timestamp2">
                            {{$t("new.title22") }}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep2 == 0" icon="el-icon-s-flag" size="large" :timestamp="course.curriculumInfo.timestamp2">
                            {{ $t("new.title22") }}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep3 == 1 && course.curriculumInfo.isExamShow == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="course.curriculumInfo.timestamp3">
                            {{ $t("curriculum.exam") }}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep3 == 2 && course.curriculumInfo.isExamShow == 1 && getExamMidAndFinal() !== 1" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="course.curriculumInfo.timestamp3">
                            {{ $t("curriculum.exam") }}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep3 == 0 && course.curriculumInfo.isExamShow == 1  && getExamMidAndFinal() !== 1" icon="el-icon-s-flag" size="large" :timestamp="course.curriculumInfo.timestamp3">
                            {{ $t("curriculum.exam") }}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep5 == 1 && course.curriculumInfo.isCovenantShow == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="course.curriculumInfo.timestamp5">
                            {{ $t("curriculum.covenant") }}
                        </el-timeline-item>
                        <el-timeline-item v-if=" course.curriculumInfo.isShowStep5 == 2 && course.curriculumInfo.isCovenantShow == 1" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="course.curriculumInfo.timestamp5">
                            {{ $t("curriculum.covenant") }}
                        </el-timeline-item>
                        <el-timeline-item v-if=" course.curriculumInfo.isShowStep5 == 0 && course.curriculumInfo.isCovenantShow == 1" icon="el-icon-s-flag" size="large" :timestamp="course.curriculumInfo.timestamp5">
                            {{ $t("curriculum.covenant") }}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep4 == 1 && course.curriculumInfo.isQuestionnaireShow == 1 && course.curriculumInfo.externalLink == null" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="course.curriculumInfo.timestamp4">
                            {{ $t("new.title65") }}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep4 == 2 && course.curriculumInfo.isQuestionnaireShow == 1 && course.curriculumInfo.externalLink == null" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="course.curriculumInfo.timestamp4">
                            {{ $t("new.title65") }}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep4 == 0 && course.curriculumInfo.isQuestionnaireShow == 1 && course.curriculumInfo.externalLink == null" icon="el-icon-s-flag" size="large" :timestamp="course.curriculumInfo.timestamp4">
                            {{ $t("new.title65") }}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep6 == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="course.curriculumInfo.timestamp6">
                            {{ $t("new.title21") }}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep6 == 2" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="course.curriculumInfo.timestamp6">
                            {{ $t("new.title21") }}
                        </el-timeline-item>
                        <el-timeline-item v-if="course.curriculumInfo.isShowStep6 == 0" icon="el-icon-s-flag" size="large" :timestamp="course.curriculumInfo.timestamp6">
                            {{ $t("new.title21") }}
                        </el-timeline-item>
                    </el-timeline>
                </div>
                <div v-if="(course.curriculumInfo.isShowStep1 != 1 || course.curriculumInfo.isShowStep2 != 1 || ((course.curriculumInfo.isShowStep3 != 1 && getExamMidAndFinal() !== 1) || (course.curriculumInfo.isShowStep3 !== 2 && getExamMidAndFinal() === 1)) || course.curriculumInfo.isShowStep4 != 1 || course.curriculumInfo.isShowStep5 != 1) && course.curriculumInfo.isFinished == 0">
                    <div class="SubmitPaper_pnn">{{ $t("new.title34") }}</div>
                </div>
                <div v-if="course.curriculumInfo.isFinished == 1">
                    <div class="SubmitPaper_pnn">{{ $t("new.title34") }}</div>
                </div>
                <div v-if=" course.curriculumInfo.isShowStep1 == 1 && course.curriculumInfo.isShowStep2 == 1 && (course.curriculumInfo.isShowStep3 == 1 || (course.curriculumInfo.isShowStep3 == 2 && getExamMidAndFinal() === 1)) && course.curriculumInfo.isShowStep4 == 1 && course.curriculumInfo.isShowStep5 == 1 && course.curriculumInfo.isFinished == 0">
                    <div class="SubmitPaper_pn" @click="submit()">
                        {{ $t("new.title34") }}
                    </div>
                </div>
            </template>
        </el-dialog>

        <!-- Loading -->
        <loading :showLoading="loading" />
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import menuCurriculum from "@/components/curriculum/menu";
    import loading from "@/components/loading/loading";
    import md5 from "js-md5";

    export default {
        data() {
            return {
                loading: true,
                showFinished: false,
                child: menuCurriculum,
                userId: null,
                exams: [],
                statistics: [],
                examEnd: {},
                course: null
            };
        },
        components: {
            menuCurriculum,
            loading
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
                myCourses: (state) => state.schoolBussiness.myCourses,
            }),
        },
        created () {
            this.$autoLogin().then(
                () => {
                    this.init();
                },
                () => {
                    this.$router.push({
                        path: "/home",
                    });
                }
            );
        },
        methods: {

            // Khởi động
            init: async function () {
                // Hiện loading
                this.loading = true;

                // UserID
                this.userId = window.sessionStorage.getItem("id");

                // Lấy data
                let outlineInfo = eval("(" + this.$route.query.outlineInfo + ")");

                // Lấy thông tin khóa học
                this.course = await this.getCourseInfo({id: outlineInfo.courseId});
                this.course['courseId'] = outlineInfo.courseId;

                // Lấy thông tin mục lục
                this.course['curriculumInfo'] = await this.getCurriculumInfo({id: this.course.courseId});

                // Lấy thông tin loại khóa học
                this.course['category'] = await this.getCourseCategory({id: this.course.courseId});

                // Lấy danh sách btns
                let btns = this.getCurriculum(this.course.category);

                // Xử lý trạng thái của btns
                this.btns = await this.convertBtns(btns[0].menuList);

                // Tải thông tin mục lục
                this.loadMenu(this.course.courseId);

                // Ẩn loading
                this.loading = false;

                // 14.2 Cuối kì
                if (this.course.examFlag == 2) {
                    let message = [];
                    let h = this.$createElement;
                    message.push(h("p", null, this.$i18n.t("new.title99")));
                    this.$confirm(h("p", null, message), this.$i18n.t("js.hint"), {
                        confirmButtonText: this.$i18n.t("js.confirm"),
                        cancelButtonText: this.$i18n.t("js.cancel"),
                        cancelButtonClass: "btn-custom-cancel",
                        type: "",
                    }).then(() => {
                        this.$router.push({
                            path: "exam/begins",
                            query: {
                                courseId: this.course.courseId,
                                courseName: this.course.courseName,
                                redirect: true
                            },
                        });
                    }).catch(() => {});
                }

                // Hiển thị dialog kết thúc
                if (this.course.category != 5 && this.course.category != 6 && this.course.category != 7 && this.course.category != 8) {
                    if (
                        this.course.curriculumInfo.isShowStep1 == 1 &&
                        this.course.curriculumInfo.isShowStep2 == 1 &&
                        this.course.curriculumInfo.isShowStep3 == 1 &&
                        this.course.curriculumInfo.isShowStep4 == 1 &&
                        this.course.curriculumInfo.isShowStep5 == 1 &&
                        this.course.curriculumInfo.isShowStep6 != 1
                    ) {
                        // Load cpn hoàn thành khóa học
                        this.showFinished = true;
                    }
                }
            },

            getExamMidAndFinal: function () {
              //Chỉ có kì thi giữa kì
              if(this.btns[3].show === true && this.btns[4].show === false) {
                return 1
              }
              //Chỉ có kì thi cuối kì
              if(this.btns[3].show === false && this.btns[4].show === true) {
                return 2
              }
              //Có c kì thi cuối kì và giữa kì
              if(this.btns[3].show === true && this.btns[4].show === true) {
                return 3
              }
            },

            // Load dữ liệu menu
            loadMenu: function (courseId) {
                this.$refs.child.init({courseId: courseId, courseName: this.course.courseName});
            },

            // Lấy chiều rộng dialog
            setDialogWidth: function() {
                let val = document.body.clientWidth;
                const def = 1024;

                let width = "40%";

                if (val < def) {
                    width = "90%";
                }

                return width;
            },

            // Lấy thông tin mục lục
            getCurriculumInfo: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCurriculumInfo", {
                            courseId: data.id
                        })
                        .then(response => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response)
                        });
                });
            },

            // Lấy trạng thái đối với khóa học
            getExamStatus: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getExamStatus", {
                            courseId: data.courseId,
                            studentId: data.studentId
                        })
                        .then(response => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response)
                        });
                });
            },

            // Lấy thông tin khóa học
            getCourseInfo: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/coursesPurchase/getCoursePurchaseDetails", {
                            courseId: data.id,
                            languageType: this.$lang(),
                            userId: window.sessionStorage.getItem("id")
                        })
                        .then(response => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response)
                        });
                });
            },

            // Lấy thông tin loại khóa học
            getCourseCategory: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCourseCategory", {
                            courseId: data.id,
                        })
                        .then((response) => {
                            resolve(response.data.courseCategoryCode);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Gọi đến method ứng với item
            handleClickItem: function (item) {
                if (item.medthod) {
                    this[item.medthod](item)
                }
            },

            // Xử lý menu btns
            convertBtns: async function (data) {

                // Key: Bảng khảo sát
                let keyBKS = data.findIndex(item => item.name == 'BANG__KHAO__SAT');

                // Key: Thi cuoi ki
                let keyTCK = data.findIndex(item => item.name == 'THI__CUOI__KI');

                // Key: Câu trả lời sai
                let keyWrongAnswer = data.findIndex(item => item.name == 'CAU__TRA__LOI__SAI');

                // Key: Xuất ghi chú
                let keyNote = data.findIndex(item => item.name == 'XUAT__GHI__CHU');

                // Key: Finished course
                const keyFinished = data.findIndex(item => item.name == 'TIEN__DO__KHOA__HOC');

                // Key: certificate
                const keyCertificate = data.findIndex(item => item.name == 'CHUNG__CHI');

                // Btn: Bảng khảo sát
                data[keyBKS]['externalLink'] = this.course.curriculumInfo.externalLink != null ? true : false;
                data[keyBKS].show = this.course.curriculumInfo.externalLink != null ? true : data[keyBKS].show;

                // Btn: Câu trả lời sai
                data[keyWrongAnswer].show = parseInt(this.course.curriculumInfo.errBookShow) == 0 ? false : data[keyWrongAnswer].show;

                // Btn: Xuất ghi chú
                let exams = [9, 10, 11, 12].filter(x => x == this.course.category);
                data[keyNote].show = this.mobile || exams.length ? false : data[keyNote].show;

                if (parseInt(this.course.examFlag) != 0) {
                    data[keyTCK].show = true;
                }

                // check show midterm exam
                let isMidTermExam = await this.getExamList({id: this.course.courseId});
                let isFinalExam = await this.getFinalExamList({id: this.course.courseId});
                data.forEach(el => {
                    if (isMidTermExam.length == 0) {
                        if (el.name == "THI__GIUA__KI") el.show = false;
                    } else {
                        if (el.name == "THI__GIUA__KI") el.show = true;
                    }
                })
                data.forEach(el => {
                    if (isFinalExam == 0) {
                        if (el.name == "THI__CUOI__KI") el.show = false;
                    } else {
                        if (el.name == "THI__CUOI__KI") el.show = true;
                    }
                })
                if (this.course.curriculumInfo.isFinished == 1) {
                    data[keyCertificate].show = true;
                    data[keyFinished].show = false;
                }

                return data;
            },
            // Lấy ra danh sách bài thi cuối kỳ
            getFinalExamList: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getFinalExamList", {
                            courseId: data.id
                        })
                        .then((response) => {
                            resolve(response.data || []);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
            // Lấy danh sách lịch sử thi
            getsingleCourseScoreStatistics: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/home/getsingleCourseScoreStatistics", {
                            courseId: data.id,
                            languageType: this.$lang()
                        })
                        .then((response) => {
                            resolve(response.data || []);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Lấy danh sách bài thi
            getExamList: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getExamList", {
                            courseId: data.id
                        })
                        .then((response) => {
                            resolve(response.data || []);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Lấy thông tin bài thi
            getPastExamInfo: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/studyCourseQuestion/getPastExamInfo", {
                            courseId: data.id
                        })
                        .then((response) => {
                            let result = {
                                isTemp: response.data.isTemp != null ? parseInt(response.data.isTemp) : response.data.isTemp,
                                maxScore: response.data.maxScore != null && response.data.recentScore != '--' ? parseInt(response.data.maxScore) : '--',
                                passMarks: response.data.passMarks != null ? parseInt(response.data.passMarks) : response.data.passMarks,
                                recentScore: response.data.recentScore != null && response.data.recentScore != '--' ? parseInt(response.data.recentScore) : '--',
                                isCommit: response.data.recentScore == '--' ? true : false,
                                restCount: response.data.restCount != null ? parseInt(response.data.restCount) : response.data.restCount,
                                fullMarks: response.data.fullMarks != null ? parseInt(response.data.fullMarks) : response.data.fullMarks
                            };
                            resolve(result);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            getInfoUser() {
                return new Promise((resolve, reject) => {
                    this.showLoadingFlg = true;
                    this.$api
                    .post("/personalCenter/getPersonalInfo", {
                        rToken:md5(window.sessionStorage.getItem("email")),
                        languageType:this.$lang(),
                    })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
                });
            },

            // export certificate
            async certificateExport() {
                const userInfo = await this.getInfoUser();
                this.$api
                    .post("/home/certificateExport", {
                        id: this.course.courseId,
                        courseName: this.course.courseName,
                        courseLanguage: this.$lang(),
                        area: this.$lang(),
                        name: userInfo.userName,
                        gender: userInfo.gender,
                        companyId: window.sessionStorage.getItem("companyId"),
                        jobs: userInfo.job
                    })
                    .then((response) => {
                        if (response.data != null) {
                            window.open(response.data);
                        } else {
                            this.$message.warning(window.vm.$i18n.t("js.certificateDataNone"));
                        }
                    })
                    .catch((error) => {
                    });
            },

            // Quay lại
            back: function () {
                this.$router.push({
                    name: "Aicourse",
                    query: {
                        buyCourseId: this.course.courseId
                    }
                });
            },

            // Download file csv
            noteDownLoad: function () {
                this.$api
                    .post("/courseStudy/noteExport", {
                        courseId: this.course.courseId,
                        courseLanguage: this.$lang(),
                    })
                    .then((response) => {
                        window.open(response.data, "_blank");
                    })
                    .catch((error) => {});
            },

            // Hiển thị câu trả lời sai
            wrongbook: function () {
                this.$router.push({
                    path: "exam/wrongbookBegin",
                    query: {
                        courseId: this.course.courseId,
                        courseName: this.course.courseName,
                        examFlag: this.course.examFlag,
                    },
                });
            },

            // Đi đến trang thi giữa kì
            thiGiuaKi: async function () {
                // Lấy thông tin bài thi giữa kì
                let examMidterns = await this.getExamList({id: this.course.courseId});

                // Không thể làm bài thi giữa kì vì bạn đang làm bài thi cuối kì!
                if (parseInt(this.course.examFlag) == 2) {
                    this.$message.warning(this.$i18n.t("new.title97"));
                    return;
                }

                // Xin lỗi, chưa có bài thi giữa kì nào. Vui lòng quay lại sau!
                if (examMidterns.length == 0) {
                    this.$message.warning(this.$i18n.t("new.title96"));
                    return;
                }

                // Bạn không thể làm lại bài thi khi đang chấm điểm bài thi. Vui lòng đợi một lúc cho đến khi việc chấm điểm hoàn tất.
                let status = examMidterns.some(item => item.status == 2);
                if (this.course.curriculumInfo.isExamClick == 3 || status) {
                    this.$message.warning(this.$i18n.t("js.nocorrect"));
                    return;
                }

                this.$router.push({
                    path: "exam/mid_term",
                    query: {
                        courseId: this.course.courseId,
                        courseName: this.course.courseName,
                        redirect: false,
                        examFlag: this.course.examFlag,
                    },
                });
            },

            // Đi đến trang thi cuối kì
            exam: async function () {

                // Lấy thông tin bài thi giữa kì
                let exams = await this.getExamList({id: this.course.courseId});

                // Không thể làm bài thi cuối kì vì bạn đang làm bài thi giữa kì!
                let statusMidTerm = exams.some(item => item.status == 1);
                if (statusMidTerm) {
                    this.$message.warning(this.$i18n.t("new.title98"));
                    return;
                }

                // Khoá học đã kết thúc
                if (this.course.curriculumInfo.isFinished == 1) {
                    this.$message.warning(this.$i18n.t("new.title21"));
                    return;
                }

                // Khóa học vẫn chưa được mở. Có thể nội dung sẽ bị thay đổi, nên chưa thể bắt đầu [Kì thi kết thúc]. Xin hãy chờ cho đến khi khóa học được mở khoá.
                if (this.course.curriculumInfo.isLocked == 0) {
                    this.$message.warning(this.$i18n.t("new.title81"));
                    return;
                }

                // Vui lòng tham gia“ kỳ thi cuối khóa ”sau khi hoàn thành tất cả nội dung học.
                if (this.course.curriculumInfo.isExamClick == 0) {
                    this.$message.warning(this.$i18n.t("js.jumpToexam"));
                    return;
                }

                // Không có thông tin về kỳ thi : 125730112021
                if (this.course.curriculumInfo.isExamClick == 2) {
                    this.$message.warning(this.$i18n.t("js.examDataNone"));
                    return;
                }

                // Bạn không thể làm lại bài thi khi đang chấm điểm bài thi. Vui lòng đợi một lúc cho đến khi việc chấm điểm hoàn tất.
                let statusMidTermHt = exams.some(item => item.status == 2);
                if (this.course.curriculumInfo.isExamClick == 3 || statusMidTermHt) {
                    this.$message.warning(this.$i18n.t("js.nocorrect"));
                    return;
                }

                // Bạn không thể thi cuối kỳ vì bài tập của bạn không đạt tỷ lệ đậu.
                if (this.course.curriculumInfo.isExamClick == 4) {
                    this.$message.warning(this.$i18n.t("new.title105"));
                    return;
                }

                if (this.course.curriculumInfo.isExamClick == 1) {
                    let listDataMenu = this.$refs['child'].dataCheckExercise;
                    const listExerciseNotSuccess = listDataMenu.filter(item => {
                        if (item.score == "—") {
                            return item.isExercise > 0 && 0 < parseInt(item.passingRateQuiz)
                        } else {
                            return item.isExercise > 0 && parseInt(item.score) < parseInt(item.passingRateQuiz)
                        }
                    });
                    if (!listExerciseNotSuccess.length) {
                        this.$router.push({
                            path: "exam/begins",
                            query: {
                                courseId: this.course.courseId,
                                courseName: this.course.courseName,
                                redirect: false,
                                examFlag: this.course.examFlag,
                            },
                        });
                    } else {
                        // Vui lòng tham gia“ kỳ thi cuối khóa ”sau khi hoàn thành tất cả nội dung học.
                        this.$message.warning(this.$i18n.t("js.jumpToexam"));
                        return;
                    }
                }
            },

            // Đi đến trang thành tích thi
            scoreStatistics: async function () {

                // Lấy thông tin lịch sử thi
                let statistics = await this.getsingleCourseScoreStatistics({id: this.course.courseId});

                // Xin lỗi, vì bạn chưa thi nên không thể xác nhận điểm của mình.
                if (this.course.curriculumInfo.isScoreStatistics == 0) {
                    this.$message.warning(window.vm.$i18n.t("new.title26"));
                    return;
                }

                // Bạn không thể kiểm tra điểm của mình trong khi chấm điểm bài kiểm tra. Vui lòng đợi một lúc cho đến khi việc chấm điểm hoàn thành.
                if (this.course.curriculumInfo.isScoreStatistics == 0 || statistics.length == 0) {
                    this.$message.warning(window.vm.$i18n.t("new.title27"));
                    return;
                }

                this.$router.push({
                    path: "exam/scoreStatistics",
                    query: {
                        courseId: this.course.courseId,
                        courseName: this.course.courseName,
                        num: 2
                    },
                });
            },

            // Hiển thị bảng cam kết :
            covenant: function () {

                // Vui lòng hoàn thành nội dung khóa học trước khi gửi bản cam kết.
                if (this.course.curriculumInfo.isShowStep2 != 1) {
                    this.$message.warning(window.vm.$i18n.t("new.title49"));
                    return;
                }

                // Vui lòng trả lời “ bảng cam kết ”sau khi hoàn thành “ kỳ thi cuối khóa ”.
                if(this.getExamMidAndFinal() === 1) {
                  if (this.course.curriculumInfo.isShowStep2 !== 1) {
                    this.$message.warning(window.vm.$i18n.t("new.title48"));
                    return;
                  }
                }
                if(this.getExamMidAndFinal() === 2) {
                  if (this.course.curriculumInfo.isShowStep3 !== 1) {
                    this.$message.warning(window.vm.$i18n.t("new.title48"));
                    return;
                  }
                }
                if(this.getExamMidAndFinal() === 3) {
                  if (this.course.curriculumInfo.isShowStep2 !== 1 || this.course.curriculumInfo.isShowStep3 !== 1) {
                    this.$message.warning(window.vm.$i18n.t("new.title48"));
                    return;
                  }
                }

                if (this.course.curriculumInfo.isShowStep1 == 1 && this.course.curriculumInfo.isShowStep2 == 1 && (this.course.curriculumInfo.isShowStep3 === 1 || this.course.curriculumInfo.isShowStep3 === 2)) {
                    this.$router.push({
                        path: "exam/covenant",
                        query: {
                            courseId: this.course.courseId,
                            courseName: this.course.courseName,
                            templateType: 0,
                            type: 2
                        },
                    });
                }
            },

            // Hiển thị bảng khảo sát
            questionnaire: function () {

                if (this.course.curriculumInfo.externalLink != null) {
                    window.open(this.course.curriculumInfo.externalLink);
                } else {

                    // Vui lòng hoàn thành nội dung khóa học trước khi gửi bản khảo sát.
                    if (this.course.curriculumInfo.isShowStep2 != 1) {
                        this.$message.warning(window.vm.$i18n.t("new.title47"));
                        return;
                    }

                    // Vui lòng trả lời“ bảng câu hỏi ”sau khi tham gia“ kỳ thi cuối khóa ”.
                    if(this.getExamMidAndFinal() === 1) {
                      if (this.course.curriculumInfo.isShowStep2 !== 1) {
                        this.$message.warning(window.vm.$i18n.t("js.jumpToQuestion"));
                        return;
                      }
                    }
                    if(this.getExamMidAndFinal() === 2) {
                      if (this.course.curriculumInfo.isShowStep3 !== 1) {
                        this.$message.warning(window.vm.$i18n.t("js.jumpToQuestion"));
                        return;
                      }
                    }
                    if(this.getExamMidAndFinal() === 3) {
                      if (this.course.curriculumInfo.isShowStep2 !== 1 || this.course.curriculumInfo.isShowStep3 !== 1) {
                        this.$message.warning(window.vm.$i18n.t("js.jumpToQuestion"));
                        return;
                      }
                    }

                    // Vui lòng gửi cam kết trước khi khảo sát.
                    if (this.course.curriculumInfo.isShowStep5 != 1) {
                        this.$message.warning(window.vm.$i18n.t("new.title46"));
                        return;
                    }

                    if (this.course.curriculumInfo.isShowStep1 == 1 && this.course.curriculumInfo.isShowStep2 == 1 && (this.course.curriculumInfo.isShowStep3 === 1 || this.course.curriculumInfo.isShowStep3 === 2) && this.course.curriculumInfo.isShowStep5 == 1) {

                        this.$router.push({
                            path: "exam/covenant",
                            query: {
                                courseId: this.course.courseId,
                                courseName: this.course.courseName,
                                templateType: 1,
                                type: 1
                            },
                        });
                    }
                }

            },

            // Hiển thị tiến độ khóa học
            finished: async function () {

                let status = await this.getExamStatus({ courseId: this.course.courseId, studentId: this.userId });

                if (status == -1) {
                    this.$confirm(window.vm.$i18n.t("new.title110"), window.vm.$i18n.t("new.title86"), { cancelButtonClass: "btn-nqt---show" })
                        .then(() => {})
                        .catch(() => {});
                    return;
                }

                // Load cpn hoàn thành khóa học
                this.showFinished = true;

            },

            // Hoàn thành khóa học
            submit: function () {

                this.showFinished = false;
                this.$confirm(window.vm.$i18n.t("new.title35"), window.vm.$i18n.t("js.hint"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: window.vm.$i18n.t("js.confirm"),
                    cancelButtonText: window.vm.$i18n.t("js.cancel"),
                    cancelButtonClass: "btn-custom-cancel",
                }).then(() => {
                    this.$api
                        .post("/courseStudy/updatecourseFinished", {
                            courseId: this.course.courseId
                        })
                        .then((response) => {
                            this.course.curriculumInfo = response.data;

                            // Remove course from list course vuex
                            let temp = this.myCourses.filter(el => {
                                return el.courseId != this.course.courseId;
                            });

                            this.setMyCourses(temp);

                            // Đã gửi yêu cầu kết thúc. Nhấp lại vào” Yêu cầu kết thúc ”để kiểm tra kết quả đơn đăng ký. 
                            this.$message.warning(window.vm.$i18n.t("new.title36"));

                            // Tải thông tin mục lục
                            this.loadMenu(this.course.courseId);
                        });
                }).catch(() => {});
            },

            ...mapMutations("schoolBussiness", ["setMyCourses"]),
        }
    };
</script>

<style scoped>
    .div-btn-icon li p img {
        height: 28px;
    }
    .nqt_hid {
        margin-bottom: 10px !important;
        margin-top: 15px !important;
    }
    .title_mb {
        width: calc(100% - 160px);
        position: fixed;
        font-weight: bold;
        top: 0;
        left: 48px;
        z-index: 1000;
        background-color: #0071c5;
        height: 60px;
        color: #fff;
        font-size: 13px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        line-height: 60px!important;
        padding-left: 2px;
    }
    .detail-content.mb {
        height: calc(100vh - 160px);
    }
    .disable:hover {
        cursor: context-menu;
    }

    .title {
        display: flex;
        height: 40px;
    }
    .title img {
        width: 36px;
    }
    .title span {
        font-size: 24px;
        align-items: center;
        cursor: pointer;
        font-weight: 700;
        display: flex;
        padding-left: 10px;
    }

    .item {
        margin-top: 0px;
        margin-right: 0px;
        margin-left: 0px;
    }
    @media screen and (max-width: 1200px) {
        .curriculum_main {
            min-height: unset;
        }
    }
    .SubmitPaper_pn {
        width: 75px;
        line-height: 20px;
        padding: 4px 12px 5px 12px;
        background-color: #00b7ff;
        border: solid gba(31, 30, 30) 1px;
        cursor: pointer !important;
        color: #fff;
        font-size: 14px;
        text-align: center;
        border-radius: 20px;
        margin: 30px auto;
        font-family: source-han-sans-simplified-c, sans-serif;
        font-weight: 200;
        font-style: normal;
        transition: 0.5s ease;
        font-weight: 500;
    }

    .SubmitPaper_pn:hover {
        color: #fff;
        background-color: #00d3ff;
        transition: 0.5s ease;
        cursor: pointer;
    }

    .SubmitPaper_pnn {
        width: 75px;
        line-height: 20px;
        padding: 4px 12px 5px 12px;
        background-color: #979b9c;
        border: solidr gba(31, 30, 30) 1px;
        cursor: no-drop !important;
        color: #fff;
        font-size: 14px;
        text-align: center;
        border-radius: 20px;
        margin: 30px auto;
        font-family: source-han-sans-simplified-c, sans-serif;
        font-weight: 200;
        font-style: normal;
        transition: 0.5s ease;
        font-weight: 500;
    }
    @media (max-width: 834px) {
        .nqt-export-note {
            display: none;
        }
    }
</style>
<style>
    .class1 {
        border-radius: 10px;
        color: white;
        background-color: rgba(31, 30, 30, 0.9);
    }
    .el-timeline-item__content {
        color: white;
    }
    .el-dialog__title {
        color: white;
    }
    .btn-custom-cancel {
        float: right;
        margin-left: 10px;
        margin-top: 2px;
    }
    .primarylists .titles .title {
        text-transform: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/curriculum/curriculum.vue